import React from "react";
import s from "./Profile.module.scss";
import UserDetails from "./ProfilePage";
import VerificationDocument from "../VerificationDocument/VerificationDocument";
function Profile() {

  return (
    <div className={s.wrapper}>
      <UserDetails />
      <VerificationDocument/>
    </div>
  );
}

export default Profile;
